import React, { useState, useEffect } from 'react';
import { scrollTo } from '../../utils/scrollTo';
import logo from '../../assets/logo.svg';
import './Navbar.css';

const NAV_ITEMS = ['home', 'about', 'solutions', 'contact'];

function Navbar() {
  const [menuOpen, setMenuOpen]       = useState(false);
  const [activeSection, setActive]    = useState('home');

  // Highlight nav link for whichever section is in view
  useEffect(() => {
    const onScroll = () => {
      const pos = window.scrollY + 130;
      for (let i = NAV_ITEMS.length - 1; i >= 0; i--) {
        const el = document.getElementById(NAV_ITEMS[i]);
        if (el && el.offsetTop <= pos) {
          setActive(NAV_ITEMS[i]);
          break;
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navTo = (id) => {
    setMenuOpen(false);
    scrollTo(id);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar__brand" onClick={() => navTo('home')} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Best World HealthNext logo" className="navbar__logo" />
        </div>

        <ul className={`navbar__links${menuOpen ? ' navbar__links--open' : ''}`}>
          {NAV_ITEMS.map((id) => (
            <li key={id}>
              <a
                href={`#${id}`}
                className={activeSection === id ? 'active' : ''}
                onClick={(e) => { e.preventDefault(); navTo(id); }}
              >
                {id.charAt(0).toUpperCase() + id.slice(1)}
              </a>
            </li>
          ))}
        </ul>

        <button
          className={`navbar__hamburger${menuOpen ? ' navbar__hamburger--open' : ''}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </nav>

      {menuOpen && (
        <div className="navbar__overlay" onClick={() => setMenuOpen(false)} />
      )}
    </>
  );
}

export default Navbar;
